import { useParams } from 'react-router-dom';
import { useTrailGet } from '../hooks/use-trail.hook';
import { memo, useState } from 'react';
import TrailDetailsComponent from '../components/trail-details.component';
import { Trail } from '../types/trail.types';
import { useTranslation } from 'react-i18next';
import { Button, Drawer, Empty, Spin } from 'antd';
import { WithPermissionCheck } from '../../../../auth/WithPermissionCheck';
import { HistoryOutlined } from '@ant-design/icons';
import { DEFAULT_PAGINATED_TABLE_DATA } from '../../../../../const/default-paginated-table-data.const';

const TrailDetailsContainer = ({ id }: { id: string }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { data: response, isLoading, error } = useTrailGet(id);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  if (isLoading) {
    return <Spin size="large" />;
  }

  if (error || !response?.data) {
    return <Empty />;
  }

  const { docs = [] } = response.data;

  return (
    <>
      <Button type="default" size="large" onClick={showDrawer} icon={<HistoryOutlined />}>
        {t('trails.details.view')}
      </Button>
      <Drawer
        title={t('trails.details.title')}
        placement="right"
        onClose={onClose}
        open={open}
        width={600}
      >
        <TrailDetailsComponent data={docs} />
      </Drawer>
    </>
  );
};

export default WithPermissionCheck(TrailDetailsContainer, 'trail.view');
